<div class="get-theme-container" *ngIf="show">
  <img
    class="d-none d-md-block"
    width="220px"
    src="/assets/icons/trackmage_logo_300.png"
    alt="TrackMage.com"
  />
  <div class="d-sm-block d-md-none w-100 mb-2">
    <img
      height="26px"
      src="/assets/icons/trackmage_logo_300.png"
      alt="TrackMage.com"
    />
    <button
            class="btn btn-default btn-orange btn-s btn-right btn-radius m-0"
            (click)="redirectToImportTheme()"
    >Get It Now</button>
  </div>
  <div class="d-flex align-content-center align-items-center flex-column">
    <p class="tagline m-0 mb-md-2 mt-md-2 text-center">Get Your Pre-configured Customizable Branded Tracking Page</p>
    <div class="view-modes d-flex flex-row align-content-center align-items-center justify-content-center">
      <a (click)="changeMode.emit('mobile')" class="m-2" [class.active]="mode === 'mobile'" href="javascript:void(0);" title="View Mobile">
        <svg height="20px" width="20px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 27.442 27.442" style="enable-background:new 0 0 27.442 27.442;" xml:space="preserve">
          <g>
            <path d="M19.494,0H7.948C6.843,0,5.951,0.896,5.951,1.999v23.446c0,1.102,0.892,1.997,1.997,1.997h11.546
              c1.103,0,1.997-0.895,1.997-1.997V1.999C21.491,0.896,20.597,0,19.494,0z M10.872,1.214h5.7c0.144,0,0.261,0.215,0.261,0.481
              s-0.117,0.482-0.261,0.482h-5.7c-0.145,0-0.26-0.216-0.26-0.482C10.612,1.429,10.727,1.214,10.872,1.214z M13.722,25.469
              c-0.703,0-1.275-0.572-1.275-1.276s0.572-1.274,1.275-1.274c0.701,0,1.273,0.57,1.273,1.274S14.423,25.469,13.722,25.469z
               M19.995,21.1H7.448V3.373h12.547V21.1z"/>
          </g>
        </svg>
      </a>
      <a (click)="changeMode.emit('desktop')" class="m-2" [class.active]="mode !== 'mobile'" href="javascript:void(0);" title="View Desktop">
        <svg height="20px" width="20px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 548.172 548.172" style="enable-background:new 0 0 548.172 548.172;"
             xml:space="preserve">
          <g>
            <path d="M534.75,49.965c-8.945-8.945-19.694-13.422-32.261-13.422H45.681c-12.562,0-23.313,4.477-32.264,13.422
              C4.471,58.913,0,69.663,0,82.226v310.633c0,12.566,4.471,23.315,13.417,32.265c8.951,8.945,19.702,13.414,32.264,13.414h155.318
              c0,7.231-1.524,14.661-4.57,22.269c-3.044,7.614-6.09,14.273-9.136,19.981c-3.042,5.715-4.565,9.897-4.565,12.56
              c0,4.948,1.807,9.24,5.424,12.847c3.615,3.621,7.898,5.435,12.847,5.435h146.179c4.949,0,9.233-1.813,12.848-5.435
              c3.62-3.606,5.427-7.898,5.427-12.847c0-2.468-1.526-6.611-4.571-12.415c-3.046-5.801-6.092-12.566-9.134-20.267
              c-3.046-7.71-4.569-15.085-4.569-22.128h155.318c12.56,0,23.309-4.469,32.254-13.414c8.949-8.949,13.422-19.698,13.422-32.265
              V82.226C548.176,69.663,543.699,58.913,534.75,49.965z M511.627,319.768c0,2.475-0.903,4.613-2.711,6.424
              c-1.81,1.804-3.952,2.707-6.427,2.707H45.681c-2.473,0-4.615-0.903-6.423-2.707c-1.807-1.817-2.712-3.949-2.712-6.424V82.226
              c0-2.475,0.902-4.615,2.712-6.423c1.809-1.805,3.951-2.712,6.423-2.712h456.815c2.471,0,4.617,0.904,6.42,2.712
              c1.808,1.809,2.711,3.949,2.711,6.423V319.768L511.627,319.768z"/>
          </g>
        </svg>
      </a>
    </div>
  </div>
  <button
    class="btn btn-default btn-orange btn-radius m-0 d-none d-md-block"
    (click)="redirectToImportTheme()"
  >Get It Now</button>
</div>
